import EditIncidentForm from '.';
import { useTranslation } from 'react-i18next';
import UniDialog from '../../Common/UniDialog';
import { useState } from 'react';
import _ from "lodash";

function EditIncidentFormDialog(props) {
  const { investigationId, onClose, trackingNumber, incidentList, ...rest } = props;
  const { t } = useTranslation('incidentManagement');
  const [isUpdated, setIsUpdated] = useState(false);
  let incident = _.find(incidentList, {'id': investigationId})
  const handleOnClose = () => {
    setIsUpdated(false);
    onClose(isUpdated);
  }

  return (
    <UniDialog
      title={t('incident_form')}
      onClose={handleOnClose}
      {...rest}
    >
      <EditIncidentForm
        investigationId={investigationId}
        formValueUpdated={() => setIsUpdated(true)}
        trackingNumber = {trackingNumber}
        incident = {incident}
      />
    </UniDialog>
  )
}

export default EditIncidentFormDialog;